export enum PlaceEntryType {
  BEGIN = 'BEGIN',
  END = 'END',
}
